import React from 'react';
import './Pages.css';

const About = () => {
  return React.createElement(
    'main',
    { className: 'page-content', 'data-aos': 'fade-up' },
    React.createElement(
      'div',
      { className: 'container' },
      React.createElement(
        'div',
        { className: 'page-header' },
        React.createElement('h1', null, 'About Us'),
        React.createElement('p', null, 'Learn more about InfoNaukri and our mission')
      ),
      React.createElement(
        'div',
        { className: 'about-content' },
        React.createElement(
          'div',
          { className: 'about-hero', 'data-aos': 'fade-right' },
          React.createElement('h2', null, 'Who We Are'),
          React.createElement('p', null, 'InfoNaukri is a leading E-Profile and career services provider. We help professionals build outstanding online profiles, prepare for interviews, and land their dream jobs.')
        ),
        React.createElement(
          'div',
          { className: 'about-mission', 'data-aos': 'fade-left' },
          React.createElement('h2', null, 'Our Mission'),
          React.createElement('p', null, 'To empower professionals with the tools and services they need to succeed in their careers.')
        ),
        React.createElement(
          'div',
          { className: 'about-values', 'data-aos': 'fade-up' },
          React.createElement('h2', null, 'Our Values'),
          React.createElement(
            'ul',
            null,
            React.createElement('li', null, React.createElement('strong', null, 'Excellence:'), ' We strive for excellence in everything we do'),
            React.createElement('li', null, React.createElement('strong', null, 'Innovation:'), ' We embrace innovation and new technologies'),
            React.createElement('li', null, React.createElement('strong', null, 'Integrity:'), ' We maintain the highest standards of integrity'),
            React.createElement('li', null, React.createElement('strong', null, 'Customer Focus:'), ' We put our customers first')
          )
        )
      )
    )
  );
};

export default About;